import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { MdClose } from "react-icons/md";
import { BsArrowDown } from "react-icons/bs";
import * as Yup from "yup";
import Spinner from "react-bootstrap/esm/Spinner";
import ButtonImagePermission from "../../../../components/UI/Button/ButtonImagePermission";
import TablePagination from "../../../../components/UI/Table/TablePagination";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import funcionalidades from "../../../../context/AuthContext.funcionalidades";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";
import HtmlToString from "../../../../components/Formatters/HtmlToString";

const CarregandoView = (
  <span>
    <Spinner animation="border" role="status" /> Carregando ...
  </span>
);

const removeCell = (row, setShowDesassociarConfirm, origem) => (
  <ButtonImagePermission
    permission={funcionalidades.ordemservico.deletarAltExecutor}
    className="btn-lg text-danger pa-0 p-0"
    onClick={() =>
      setShowDesassociarConfirm({
        show: true,
        body: `Deseja remover o executor ${row.nomeFormal}?`,
        context: row.codigoExecutor,
        origem,
        status: row.status,
      })
    }
    buttonImage={<MdClose />}
    tooltipImage="Remover Auditor"
  />
);

const columns = [
  {
    name: "Setor",
    selector: (row) => row.siglaOrgao,
    center: true,
    sortable: true,
  },
  {
    name: "Nome",
    selector: (row) => row.nomeFormal,
    width: "30%",
    sortable: true,
  },
  {
    name: "Matrícula",
    selector: (row) => row.matricula,
    center: true,
  },
  {
    name: "Qtd Ações",
    selector: (row) => row.quantidadeOs,
    width: "12%",
    center: true,
    sortable: true,
  },
  {
    name: "Tipos de Ação Fiscal",
    cell: (row) =>
      row.quantidadeTipoAf ? (
        <span>
          <HtmlToString html={row.quantidadeTipoAf} />
        </span>
      ) : (
        ""
      ),
    width: "33%",
    center: true,
  },
];

const validationSchema = Yup.object().shape({
  sequencialOrgao: Yup.string().default(""),
  nomeFormal: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const ListaExecutoresAssociadosInclusao = ({
  sqAltExec,
  acaoFiscal,
  alteracaoExecutor,
  ehAlteracaoExecutor,
  quantidadeIncluidosOs,
}) => {
  const [executorAssociado, setExecutorAssociado] = useState([]);
  const [sqAlteracaoExecutor, setSqAlteracaoExecutor] = useState(0);
  const [codExecutorNaoIncluido, setCodExecutorNaoIncluido] = useState("");

  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  const [showDesassociarConfirm, setShowDesassociarConfirm] = useState({
    show: false,
    body: null,
    context: null,
    origem: 0,
    status: null,
  });

  const { request: requestAssociados, data: dataAssociados, isLoading: isLoadingAssociados } = useApiClient();

  useEffect(() => {
    if (sqAltExec !== 0) {
      setSqAlteracaoExecutor(sqAltExec);
    }
  }, [sqAltExec]);

  useEffect(() => {
    if (sqAlteracaoExecutor !== 0 && (codExecutorNaoIncluido !== "" || alteracaoExecutor || ehAlteracaoExecutor)) {
      requestAssociados(apiRoutes.fiscalizacao.alteracaoexecutor.consultaExecutorAltExc, { sqAlteracaoExecutor });
    }
  }, [alteracaoExecutor, codExecutorNaoIncluido, ehAlteracaoExecutor, requestAssociados, sqAlteracaoExecutor]);

  useEffect(() => {
    if (dataAssociados) {
      setExecutorAssociado(dataAssociados.result);
      quantidadeIncluidosOs(dataAssociados.result.length);
      ehAlteracaoExecutor(false);
      setCodExecutorNaoIncluido("");
    }
  }, [dataAssociados, ehAlteracaoExecutor, quantidadeIncluidosOs]);

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData) {
      toast.success("Exclusão de executor salva com sucesso.");
      setCodExecutorNaoIncluido(deleteItemData.result.value);
    }

    if (deleteItemErrors) {
      toast.error(deleteItemErrors);
    }

    setShowDesassociarConfirm({ show: false, origem: 0 });
  }, [deleteItemData, deleteItemErrors, setShowDesassociarConfirm, requestAssociados, sqAlteracaoExecutor, acaoFiscal]);

  const columnsAssociados = [
    ...columns,
    {
      name: "Ações",
      selector: "",
      width: "10%",
      center: true,
      cell: (row) => removeCell(row, setShowDesassociarConfirm, 1),
    },
  ];

  return (
    <>
      <EfisModal
        show={showDesassociarConfirm.show}
        body={showDesassociarConfirm.body}
        loadingConfirmationAction={deleteItemIsLoading}
        closeHandler={() => setShowDesassociarConfirm({ show: false })}
        confirmationHandler={() => {
          const params = {
            sequencialAlteracaoExecutor: sqAlteracaoExecutor,
            codigoExecutor: showDesassociarConfirm.context,
            status: showDesassociarConfirm.status,
          };
          deleteItemRequest(apiRoutes.fiscalizacao.alteracaoexecutor.excluirAltExecOs, params);
        }}
      />
      {executorAssociado.length > 0 && (
        <>
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow mb-4">
                <div className="card-header pt-3 pb-0 flex-row w-100">
                  <h6 className="m-0 font-weight-bold text-primary flex-grow-1 py-3">
                    Executores salvos para inclusão{" "}
                  </h6>
                </div>

                <div className="card-body">
                  <DataTable
                    noHeader
                    title="Executores salvos para inclusão"
                    keyField="id"
                    columns={columnsAssociados}
                    data={executorAssociado}
                    progressPending={isLoadingAssociados}
                    noDataComponent="Nenhum registro para exibir"
                    progressComponent={CarregandoView}
                    defaultSortFieldId={1}
                    sortIcon={<BsArrowDown />}
                    pagination
                    sortable
                    pointerOnHover
                    paginationComponent={TablePagination}
                  />
                </div>
              </div>
            </div>
          </div>{" "}
        </>
      )}{" "}
    </>
  );
};

export default ListaExecutoresAssociadosInclusao;
